<div
  id="role-permission-management-component"
  class="component-inner-wrapper role-permission-management-component-class"
>
  <main class="main-content">
    <div class="container">
      <div class="breadcrumb">
        <span class="ele_link" [routerLink]="['/user-management/customers']"
          >USER MANAGEMENT</span
        >
        <span>></span>
        <span>Role &amp; Permission Management</span>
      </div>

      <h1 class="page-title mb-4">Role &amp; Permission Management</h1>

      <div class="content-wrapper rpm-content">
        <section class="rpm-summary-cards row g-3 mb-4" aria-label="Role statistics">
          <div
            class="col-12 col-sm-6 col-xl-3"
            *ngFor="let card of summaryCards"
          >
            <a
              *ngIf="card.link; else staticSummaryCard"
              class="rpm-stat-card rpm-stat-card--clickable"
              [routerLink]="card.link"
              [queryParams]="card.queryParams ?? null"
              [attr.aria-label]="card.label + ': ' + card.value + '. Open User List filtered by role.'"
            >
              <div class="rpm-stat-label">{{ card.label }}</div>
              <div class="rpm-stat-value">{{ card.value }}</div>
            </a>
            <ng-template #staticSummaryCard>
              <div class="rpm-stat-card">
                <div class="rpm-stat-label">{{ card.label }}</div>
                <div class="rpm-stat-value">{{ card.value }}</div>
              </div>
            </ng-template>
          </div>
        </section>

        <div class="tab-section row mt-4">
          <div class="col-12">
            <mat-tab-group
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              [selectedIndex]="selectedTabIndex"
              (selectedIndexChange)="onSelectedTabIndexChange($event)"
            >
              <mat-tab label="Roles">
                <ng-container *ngIf="rolesManagementComponent">
                  <ng-container
                    *ngComponentOutlet="rolesManagementComponent"
                  ></ng-container>
                </ng-container>
              </mat-tab>

              <mat-tab label="Permissions">
                <ng-container *ngIf="permissionsManagementComponent">
                  <ng-container
                    *ngComponentOutlet="permissionsManagementComponent"
                  ></ng-container>
                </ng-container>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="rpm-tab-label-long"
                    >Role &amp; Permission Assignment</span
                  >
                </ng-template>
                <ng-container *ngIf="rolePermissionAssignmentComponent">
                  <ng-container
                    *ngComponentOutlet="rolePermissionAssignmentComponent"
                  ></ng-container>
                </ng-container>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="rpm-tab-label-long"
                    >Installer Role &amp; Permission Assignment</span
                  >
                </ng-template>
                <ng-container *ngIf="installerRolePermissionAssignmentComponent">
                  <ng-container
                    *ngComponentOutlet="installerRolePermissionAssignmentComponent"
                  ></ng-container>
                </ng-container>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
